import { dsClass } from '../../common/constants/dsClasses.js';
import { nameMsg, t, userInformationMsg } from '../../common/i18n/index.js';
import { Loading } from '../Loading/Loading.js';
import type { ContactHeader } from '../../generated/api/models.js';

interface CustomerOrderCustomerInfoParams {
  ordererContact: ContactHeader | undefined;
}

export const CustomerOrderCustomerInfo = ({ ordererContact }: CustomerOrderCustomerInfoParams) => {
  return ordererContact ? (
    <div className="of-customer-order-details__content--customer-info">
      <h3 className={dsClass.MARGIN_BOTTOM_1}>{t.T1WX(userInformationMsg)}</h3>
      <div>
        <div>
          <strong>{t.PNS1(nameMsg)}</strong>
        </div>
        <div>{`${ordererContact.firstName} ${ordererContact.lastName}`}</div>
        <div>{ordererContact.email}</div>
      </div>
    </div>
  ) : (
    <Loading />
  );
};
